import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { PriceInput } from 'page/StartScreen/combine/price/PriceInput'

export const PriceStep = observer(() => {
  return <Vertical gap={12}>
    <PriceInput type="min" />
    <PriceInput type="max" />
  </Vertical>
})
